
<template>
    <div class="width-100-percent">
        <div v-if="!onlineInstitute">
            <PersonalProfile />
        </div>
        <div v-else class="ui-content dashboard">
            <div class="page-user user leaderboard-tab" >
            <v-tabs
                    v-model="tab"
                    background-color
                    class="elevation-2 cust-tab"
                    :centered="centered"
                    :grow="grow"
                    :vertical="vertical"
                    :right="right"
                    :prev-icon="prevIcon ? 'mdi-arrow-left-bold-box-outline' : undefined"
                    :next-icon="nextIcon ? 'mdi-arrow-right-bold-box-outline' : undefined"
                    :icons-and-text="icons"
                >
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab key="PersonalDetails" :href="'#PersonalDetails'">Personal Details</v-tab>
                    <!-- <v-tab v-if="!parent" key="ParentDetails" :href="'#ParentDetails'">Parent Details</v-tab>
                    <v-tab key="TargetExam" :href="'#TargetExam'">{{ parent ? 'Student Details' : 'Target Exam'}}</v-tab> -->
                    <v-tabs-items :touchless="true" v-model="tab">
                        <template>
                            <v-tab-item key="PersonalDetails" :value="'PersonalDetails'">
                                <PersonalProfile />
                            </v-tab-item>
                            <!-- <v-tab-item key="ParentDetails" :value="'ParentDetails'">
                                <ParentDetails />
                            </v-tab-item>
                            <v-tab-item key="TargetExam" :value="'TargetExam'">
                                <TargetExam />
                            </v-tab-item> -->
                        </template>
                    </v-tabs-items>
                </v-tabs>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import constants from "@/utils/constants.js";
import PersonalProfile from "@/components/profile/PersonalProfile.vue";
import TargetExam from "@/components/profile/TargetExam.vue";
import ParentDetails from "@/components/profile/ParentDetails.vue";

export default {
    name: "Profile",
    mounted() {
        this.onlineInstitute = (this.user && this.user.institute == constants.ONLINE_INSTITUTE_ID) ? true : false;
        this.parent = this.user && this.user.role_id == this.roleIds.PA ? true : false
    },
    data() {
        return {
            tab: null,
            prevIcon: false,
            nextIcon: false,
            tabClicked: false,
            onlineInstitute: false,
            right: false,
            vertical: false,
            grow: false,
            icons: false,
            centered: false,
            parent: false
        };
    },

    computed: {
        ...mapState("userStore", ["user"]),
        ...mapState("utilStore", ["countryList"]),
    
    },
    components: { PersonalProfile, TargetExam, ParentDetails }
};
</script>